import { INotification } from "@freetech/models/notifications";
import { NotificationDisplayParams } from "./types";
import { getNotificationIcon } from "./utils/getNotificationIcon";
import { getNotificationTitle } from "./utils/getNotificationTitle/getNotificationTitle";
import { getNotificationDescription } from "./utils/getNotificationDescription";
import { getNotificationSeverity } from "./utils/getNotificationSeverity";
import { handleNotificationClick } from "./utils/handleNotificationClick";

export const getNotificationDetails = (
  notification: INotification
): NotificationDisplayParams => {
  const severity = getNotificationSeverity(notification);

  const icon = getNotificationIcon(notification.type);

  const title = getNotificationTitle(notification);
  const description = getNotificationDescription(notification);
  const clickDestination = handleNotificationClick(notification);

  return {
    icon,
    title,
    description,
    severity,
    clickDestination,
    isClickable: !!clickDestination,
  };
};

export { getNotificationIcon } from "./utils/getNotificationIcon";
export { getNotificationTitle } from "./utils/getNotificationTitle/getNotificationTitle";
export { getNotificationDescription } from "./utils/getNotificationDescription";
export { getNotificationSeverity } from "./utils/getNotificationSeverity";
export { handleNotificationClick } from "./utils/handleNotificationClick";